<div class="container" [formGroup]="loginForm">
  <input type="text" formControlName="email" />
  <input type="password" formControlName="password" />
  <button class="btn" (click)="login()">ENTRAR</button>
</div>
